

import {Component, Vue} from "vue-property-decorator"
import {Medewerker} from "@/types/Medewerker";

@Component({})
export default class Medewerkers extends Vue {
  name!: "medewerkers"

  // The positie is a unique key to look this up in the language translations.
  // This is not needed for the name since that stays the same in all the languages.
  medewerkers: Array<Medewerker> = [
    {
      naam: "F. De Groote",
      positie: "fdg"
    }, {
      naam: "I. Meersman",
      positie: "im"
    }, {
      naam: "C. Van Eyndhoven",
      positie: "cve"
    }, {
      naam: "A. Lahmidi",
      positie: "al"
    }
  ]
}
